import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

/**
 * 	Wichtig:
 * 	Der 'webpackChunkName'-Kommentar sorgt dafür, dass alle Chunks in einer Datei gebündelt werden
 * 	siehe: 		https://router.vuejs.org/guide/advanced/lazy-loading.html
 * 	Zieldatei: 	EXT:nnconfigurator/Resources/Vue/dist/static/js/nnconfigurator.0.js
 * 
 */
export default new Router({
	routes: [
		{ 
			path: '/preloader',
			name: 'preloader',
			component: () => import( /* webpackChunkName: "components" */ "@/views/Preloader") 
		},
		{
			path: '/index',
			name: 'index',
			component: () => import( /* webpackChunkName: "components" */ "@/views/Index")	
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js